import { render, staticRenderFns } from "./AboutUsContent.vue?vue&type=template&id=fa645e58&scoped=true"
import script from "./AboutUsContent.vue?vue&type=script&lang=ts"
export * from "./AboutUsContent.vue?vue&type=script&lang=ts"
import style0 from "./AboutUsContent.vue?vue&type=style&index=0&id=fa645e58&prod&lang=css"
import style1 from "./AboutUsContent.vue?vue&type=style&index=1&id=fa645e58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa645e58",
  null
  
)

export default component.exports